import { RiCloseFill } from 'react-icons/ri';
import { InputHTMLAttributes, forwardRef, useState } from 'react';
import cx from 'classnames';
import styles from './TokenInput.module.scss';
import Card from '../Card';
import Typography from '../Typography';

export interface TokenInputProps {
  onChange: (newValue: string[]) => void;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  className?: string;
  disabled?: boolean;
  label?: string;
  name: string;
  value?: string[];
}

function TokenInput(props: TokenInputProps, ref: any) {
  const [input, setInput] = useState<string>('');
  const value = new Set(props.value);
  const showPlaceholder =
    props.inputProps?.placeholder && !input && !value.size;

  return (
    <Card
      className={cx(props.className, styles.container)}
      backgroundColor="background-2"
      tabIndex="-1"
      padding="1rem"
      ref={ref}
      as="ul"
    >
      {props.value?.map((text, key) => (
        <Card
          backgroundColor="background-1"
          padding="0.6rem 0.7rem 0.6rem 0.725rem"
          className={styles.token}
          key={key}
          as="li"
        >
          <Typography className={styles.value} textWeight="bold" textType="p4">
            {text}
          </Typography>
          <button
            onClick={() => {
              value.delete(text);
              props.onChange(Array.from(value));
            }}
            className={styles.btn}
            type="button"
          >
            <RiCloseFill size="100%" />
          </button>
        </Card>
      ))}
      <li className={styles.inputWrapper}>
        <input
          {...props.inputProps}
          placeholder={
            showPlaceholder ? props.inputProps?.placeholder : 'Add Item'
          }
          onChange={(e) => setInput(e.target.value)}
          className={styles.input}
          onKeyDown={({ key }) => {
            if (key === 'Enter') {
              value.add(input);
              props.onChange(Array.from(value));
              setInput('');
            }
          }}
          value={input}
        />
      </li>
    </Card>
  );
}

export default forwardRef(TokenInput);
